var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVelocimeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.2,2.7A13.4,13.4,0,0,0,14,0,13.4,13.4,0,0,0,5.8,2.7,14,14,0,0,0,0,14a13.2,13.2,0,0,0,.4,3.4,3.6,3.6,0,0,0,2.3,2.5H3.9a3.5,3.5,0,0,0,2.3-.9l.8-.5a11.5,11.5,0,0,1,7-2.3,11.5,11.5,0,0,1,7,2.3l.8.6a4,4,0,0,0,3.5.7,3.6,3.6,0,0,0,2.3-2.5A13.2,13.2,0,0,0,28,14,14,14,0,0,0,22.2,2.7ZM12.6,14.4h-.1v-.5a1.5,1.5,0,0,1,3,0v.5H12.6Zm13,2.5a1.4,1.4,0,0,1-.9,1.1,2.1,2.1,0,0,1-1.6-.3l-.9-.7a12.6,12.6,0,0,0-4.8-2.3,2.8,2.8,0,0,0,.1-.9,3.1,3.1,0,0,0-.6-1.9L19.8,9a5.8,5.8,0,0,1,1,1.2l1.7-1.1a10.2,10.2,0,0,0-17,0l1.7,1.1A8.2,8.2,0,0,1,14,6.5a8.6,8.6,0,0,1,4.2,1.2l-2.8,2.9a3.2,3.2,0,0,0-1.4-.3,3.5,3.5,0,0,0-3.5,3.5,2.8,2.8,0,0,0,.1.9A12.6,12.6,0,0,0,5.8,17l-.9.7a2,2,0,0,1-1.5.3,1.4,1.4,0,0,1-1-1.1A9.2,9.2,0,0,1,2,14,12,12,0,0,1,7,4.3,11.5,11.5,0,0,1,14,2a11.5,11.5,0,0,1,7,2.3A12,12,0,0,1,26,14,9.2,9.2,0,0,1,25.6,16.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVelocimeter);
export default __webpack_public_path__ + "static/media/icon-velocimeter.f5f65c7e210964d85e776cbe4335ac3c.svg";
export { ForwardRef as ReactComponent };